import React, { useState, useId } from 'react';
import Button from 'components/Button';
import Input from 'components/Input';
import { useTranslation } from 'services/hooks';
import PropTypes from 'prop-types';

import './style.css';

const MultiSelect = ({ dataBank, onChange, selectedDataBank, bankTitle, selectedTitle }) => {
	const [bank, setBank] = useState(dataBank || []);
	const [selectedData, setSelectedData] = useState(selectedDataBank || []);

	const [bankSearchQuery, setBankSearchQuery] = useState('');
	const [selectedDataSearchQuery, setSelectedDataSearchQuery] = useState('');

	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'input';

	const _handleBankCheck = ({ target }) => {
		let list = [...bank];
		list = updateOnCheckboxToggle(list, parseInt(target.value));
		setBank(list);
	};

	const _handleSelectedCheck = ({ target }) => {
		let list = [...selectedData];
		list = updateOnCheckboxToggle(list, parseInt(target.value));
		setSelectedData(list);
	};

	const updateOnCheckboxToggle = (list, idToToggle) => {
		const currentData = list.find(data => data.id === idToToggle);
		if (currentData.checked) currentData.checked = !currentData.checked;
		else currentData.checked = true;
		list = list.map(data => (data.id === idToToggle ? currentData : data));
		return list;
	};

	const _handleInsertToClass = () => {
		const selectedList = [...selectedData];
		const bankList = bank.filter(data => {
			if (data.checked) selectedList.push({ ...data, checked: false });
			return !data.checked;
		});

		setSelectedData(selectedList);
		setBank(bankList);
		onChange(selectedList);
	};

	const _handleRemoveFromClass = () => {
		const bankList = [...bank];
		const selectedList = selectedData.filter(data => {
			if (data.checked) bankList.push({ ...data, checked: false });
			return !data.checked;
		});

		setSelectedData(selectedList);
		setBank(bankList);
		onChange(selectedList);
	};

	//RENDER FUNCTIONS
	const _renderCheckbox = ({ description, checked, id }, onCheckboxChange, idx) => (
		<Checkbox description={description} id={id} onChange={onCheckboxChange} checked={checked} key={idx} />
	);

	const _renderSelected = selectedData
		?.filter(({ description }) => description?.toLowerCase().includes(selectedDataSearchQuery.toLowerCase()))
		?.map((element, idx) => _renderCheckbox(element, _handleSelectedCheck, idx));

	const _renderBank = bank
		?.filter(({ description }) => description?.toLowerCase().includes(bankSearchQuery.toLowerCase()))
		?.map((element, idx) => _renderCheckbox(element, _handleBankCheck, idx));

	return (
		<div className="MultiSelect">
			<div className="MultiSelect__wrapper left">
				<div className="MultiSelect__title">{bankTitle}</div>
				<Input startIcon="searchIcon" colorIcon="#c1c1c1" onChange={({ target }) => setBankSearchQuery(target.value)} />
				<div className="MultiSelect__list ">{_renderBank}</div>
				<div className="MultiSelect__button_wrapper">
					<Button
						title={getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_multi_select_move_buttons`)}
						extraClassName="transparent"
						small
						endIcon="rightArrow"
						onClick={_handleInsertToClass}
					/>
				</div>
			</div>

			<div className="MultiSelect__wrapper right">
				<div className="MultiSelect__title">
					{selectedTitle} <span>( {selectedDataBank.length} )</span>
				</div>
				<Input startIcon="searchIcon" colorIcon="#c1c1c1" onChange={({ target }) => setSelectedDataSearchQuery(target.value)} />
				<div className="MultiSelect__list ">{_renderSelected}</div>
				<div className="MultiSelect__button_wrapper">
					<Button
						title={getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_multi_select_remove_button`)}
						small
						startIcon="rightArrow"
						extraClassName="Remove transparent"
						onClick={_handleRemoveFromClass}
					/>
				</div>
			</div>
		</div>
	);
};

export default MultiSelect;

export const Checkbox = ({ description, onChange, id, checked = false, name, stateless = false }) => {
	const checkboxId = useId();

	const inputStateProps = { checked };
	if (stateless) delete inputStateProps.checked;

	return (
		<div className="Checkbox">
			<input type="checkbox" id={checkboxId} name={name} onChange={onChange} value={id} {...inputStateProps} />
			<label htmlFor={checkboxId}>{description}</label>
		</div>
	);
};

MultiSelect.propTypes = {
	onChange: PropTypes.func.isRequired,
};
